// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AnalyticsItemModel from '../../model/analytics-item-model';
import AnalyticsItemDTO from '../dto/analytics-item-dto';
import dtoSchema from '../schemas/analytics-item-schema';

export default abstract class AnalyticsItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AnalyticsItemDTO>) {
    super();
    if (data) {
      this.yearAndMonth = data.yearAndMonth ?? undefined;
      this.countShowDetails = data.countShowDetails;
      this.countAddToTour = data.countAddToTour;
      this.countRemoveFromTour = data.countRemoveFromTour;
      this.countDownloadTour = data.countDownloadTour;
    }
  }
  /**
  */
  yearAndMonth?: string;
  /**
  * @type {int32}
  */
  countShowDetails?: number;
  /**
  * @type {int32}
  */
  countAddToTour?: number;
  /**
  * @type {int32}
  */
  countRemoveFromTour?: number;
  /**
  * @type {int32}
  */
  countDownloadTour?: number;

  static toModel(dto: DeepPartial<AnalyticsItemDTO>): AnalyticsItemModel;
  static toModel(dto: DeepPartial<AnalyticsItemDTO> | undefined | null): AnalyticsItemModel | undefined;
  static toModel(dto: DeepPartial<AnalyticsItemDTO> | undefined | null): AnalyticsItemModel | undefined {
    return dto ? new AnalyticsItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AnalyticsItemModel> | AnalyticsItemModel): AnalyticsItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      yearAndMonth: unwrapped.yearAndMonth,
      countShowDetails: unwrapped.countShowDetails,
      countAddToTour: unwrapped.countAddToTour,
      countRemoveFromTour: unwrapped.countRemoveFromTour,
      countDownloadTour: unwrapped.countDownloadTour,
    } as AnalyticsItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AnalyticsItemModel, can not map to AnalyticsItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
